import { connect } from 'react-redux'

import Suggestions, { ContactSearchResult } from '../components/suggestions'
import { AircallEventAttributes } from 'lib/models/aircall-event'

type State = {
  call: AircallEventAttributes
  searchResults: ContactSearchResult[]
}

const mapStateToProps = (state: State) => {
  return {
    call: state.call,
    searchResults: state.searchResults,
  }
}

export default connect(mapStateToProps)(Suggestions)
